import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import * as icon from "../../services/icon";
import * as api from "api/api";
import * as ledgerModal from "services/ledger";
import BuyingModal from "components/Modals/BuyingModal";
import { connectResponse } from "utils/connectResponse";
import { fetchWalletSuccess } from "../../redux/actions/wallet";
import ConnectModal from "components/Modals/ConnectModal";
import { ClOSE } from "src/constants/images";
import { replaceFloatValue } from "utils/replaceFloatValue";
import { WALLET } from "src/constants/routes";
import ConnectWalletModal from "components/Modals/ConnectWalletModal";
import { fetchMarketPlaceData } from "../../redux/actions/marketplace";
import {
  fetchLatestGangstersData,
  fetchLatestMintedGangstersData,
} from "../../redux/actions/home";
import ConnectionOptionModal from "components/Modals/ConnectionOptionModal";
import { WALLET_TYPE } from "src/constants/walletType";

const SalePrice = ({
  preSaleStarted,
  indvidualReserve,
  totalReserve,
  reloadReservation,
  checkReserveEndDate,
  checkPreSaleEndDate,
  preSaleEndDate,
}) => {
  const [totalNFT, setTotalNFT] = useState(0);
  const [creationCostPer, setCreationCost] = useState(0);
  const [totalCost, setTotalCost] = useState(0);
  const [nftCount, setNftCount] = useState(0);
  const [buyLoading, setBuyLoading] = useState(false);
  const [buySuccess, setBuySuccess] = useState({ status: "loading" });
  const [connectWallet, setConnectWallet] = useState(false);
  const [alert, setAlert] = useState(false);
  const [connectLoading, setConnectLoading] = useState(false);
  const [connectSuccess, setConnectSuccess] = useState({ status: "loading" });
  const [walletConnection, setWalletConnection] = useState(false);

  const address = useSelector((state) => state.wallet.walletAddress);
  const { walletType, walletPath, transport } = useSelector(
    (state) => state.wallet
  );
  //icx price in usd
  const icxInUSD = useSelector((state) => state.icxPricing.price);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getSalePrice = async () => {
    getNftSold();
    const price = await getCurrentSalePrice(1);

    setCreationCost(price);
  };

  useEffect(() => {
    window.addEventListener("ICONEX_RELAY_RESPONSE", eventHandler, false);

    getSalePrice();

    return () => {
      window.removeEventListener("ICONEX_RELAY_RESPONSE", eventHandler);
    };
  }, []);

  const eventHandler = async (event) => {
    const response = await connectResponse(event);

    if (response.type == "address") {
      dispatch(fetchWalletSuccess(response.data, "iconex"));
      setConnectSuccess({ status: "success" });
    } else if (response.type == "json-RPC") {
      getTxResultWithTimer(response.data.result);
    } else if (response.type === "cancel") {
      setBuySuccess({ status: "cancel" });
      setConnectSuccess({ status: "cancel" });
    } else {
      setBuySuccess({ status: "error" });
      setConnectSuccess({ status: "error" });
    }
  };

  const getTxResultWithTimer = (txHash) => {
    setTimeout(() => {
      getTx(txHash);
    }, 500);
  };

  const getTx = async (tx) => {
    const res = await icon.getTransactionResult(tx);

    if (res.status === "pending") {
      getTxResultWithTimer(tx);
    } else {
      setTimeout(() => {
        setBuySuccess(res);
      }, 4000);
      await api.syncData(tx);
      getNftSold();
      dispatch(fetchMarketPlaceData());
      dispatch(fetchLatestGangstersData(1));
      dispatch(fetchLatestMintedGangstersData(1));
    }
  };

  const getNftSold = async () => {
    const nftCount = await icon.getNftsold();

    setTotalNFT(nftCount);
  };

  const getCurrentSalePrice = async (nftCount) => {
    const price = await icon.getNftCreationCost(nftCount);

    return price;
  };

  const handleInputChange = async (event) => {
    if (event.target.value < 0 || event.target.value.length === 0) {
      setNftCount(0);
      setTotalCost(0);

      return;
    }

    setNftCount(event.target.value);

    const price = await getCurrentSalePrice(event.target.value);

    setTotalCost(price);
  };

  const calculateNftCost = async () => {
    setTotalCost(nftCount * creationCostPer);
  };

  const handleLogin = async () => {
    setConnectSuccess({ status: "loading" });
    setConnectLoading(true);
    icon.handleLogin();
  };

  const createNFT = async () => {
    if (address) {
      console.log("This is he minter", address);

      if (nftCount > 20) {
        return setAlert(true);
      }

      setBuySuccess({ status: "loading" });
      setBuyLoading(true);

      const res = await icon.createNft(
        address,
        nftCount,
        Number(nftCount) * creationCostPer,
        walletType,
        walletPath,
        transport
      );

      console.log(res);

      if (walletType == WALLET_TYPE.LEDGER) {
        if (res?.name == "TransportStatusError") {
          setBuySuccess({ status: "cancel" });
        } else if (res) {
          console.log("tx: " + res);
          getTxResultWithTimer(res);
          //setBuySuccess({ status: "success" });
        } else {
          setBuySuccess({ status: "error" });
        }
      }
    } else {
      setConnectWallet(true);
    }
  };

  const handleClose = (navigate) => {
    setBuyLoading(false);
    setBuySuccess({ status: "loading" });
    if (navigate == "wallet") {
      navigate(WALLET.addSlug(WALLET.INDEX, address));
    }
  };

  const handleCloseConnect = () => {
    setConnectLoading(false);
    setConnectSuccess({ status: "loading" });
  };

  if (!preSaleStarted) {
    return <></>;
  }

  return (
    <>
      <div className="sale-price h-100">
        <div className="ps-lg-5 h-100 d-flex flex-column justify-content-between">
          <div className="pb-2">
            {!checkPreSaleEndDate ? (
              <h4 className="title mb-0 pb-1">
                <u>Pre-sale has started!</u>
              </h4>
            ) : (
              <h4 className="title mb-0 pb-1">
                <u>GangstaBet Sale is live!!</u>
              </h4>
            )}

            <h4 className="title mb-0 pb-1">
              {`${totalNFT !== 5555
                ? `Total Supply: ${totalNFT}/5555`
                : "ALL GANGSTABETS SOLD OUT"
                }`}{" "}
              || Price: {creationCostPer} ICX
            </h4>
            <h4 className="title mb-0 pb-1"></h4>

            {/* <h4 className="title mb-0 pb-1">
              Price: {creationCostPer} ICX (${""}
                  {replaceFloatValue(creationCostPer * icxInUSD)})</h4> */}

            {!checkReserveEndDate && totalNFT !== 5555 ? (
              <>
                {address && indvidualReserve > 0 ? (
                  <h5 className="mb-1 pb-3 text-white description">
                    <b>{indvidualReserve}</b> GangstaBet
                    {indvidualReserve > 1 ? "s" : ""} reserved for{" "}
                    <span className="mt-2">{address}</span>
                  </h5>
                ) : (
                  ""
                )}
                {/* {totalReserve > 0 ? (
                  <p className="description mt-2 pb-2">
                    Total reserved of gangster{totalReserve > 1 ? "s" : ""} is{" "}
                    {totalReserve}
                  </p>
                ) : (
                  ""
                )} */}
              </>
            ) : (
              ""
            )}

            {checkPreSaleEndDate ? (
              <>
                {/* <p className="description mt-2 pb-2">
                  
                </p>

                <p className="description mt-2 pb-2">
                  Pre-sale of GangstaBet has started. To ensure a fair
                  distribution, participants will not know their characters when
                  they buy. The characters will be randomly picked by an
                  on-chain algorithm and cannot to known before the purchase.
                </p>
                <p className="description mt-30 pb-2">
                  <strong>
                    During pre-sale, you will receive $GBET 3060 tokens that can
                    be used to increase the stats of your GangstaBets.
                  </strong>
                </p> */}
              </>
            ) : (
              <></>
            )}
            <input
              placeholder="Enter # of NFTs"
              onChange={handleInputChange}
              type="number"
              className="form-control my-2"
            />
          </div>

          <div className="pt-0">
            {totalCost ? (
              <>
                <p className="total mb-1 mt-1">
                  Total Price: {Number(nftCount) * Number(creationCostPer)}{" "}
                  {totalCost ? `ICX  ` : ""}
                  {totalCost
                    ? `($${replaceFloatValue(
                        Number(nftCount) * (creationCostPer * icxInUSD)
                      )})`
                    : ""}
                </p>
                {/* <p className="description">
                  You are about to purchase at the price of{" "}
                  {Number(nftCount) * creationCostPer} ICX{" "}
                  {totalCost
                    ? `($${replaceFloatValue(
                        Number(nftCount) * creationCostPer * icxInUSD
                      )}).`
                    : ""}
                </p> */}
              </>
            ) : (
              ""
            )}
            
              <button
                style={{
                  backgroundColor: "#fff",
                }}
                className="btn btn-light"
                onClick={createNFT}
                disabled={Number(nftCount) <= 0}
              >
                BUY!
              </button>
          </div>
          {alert && (
            <div
              className="alert alert-warning alert-dismissible fade show"
              role="alert"
            >
              You can only buy maximum of 20 NFTs at one time.
              <span className="ms-2 mb-1 close" onClick={() => setAlert(false)}>
                <img src={ClOSE.SOURCE} alt="close" className="mb-0" />
              </span>
            </div>
          )}
        </div>
        <ConnectModal
          isVisible={connectWallet}
          onClose={() => setConnectWallet(false)}
          onConnect={() => setWalletConnection(true)}
          icxAmount={creationCostPer}
        />
        <BuyingModal
          isVisible={buyLoading}
          response={buySuccess}
          onClick={handleClose}
          nftCount={Number(nftCount)}
          totalCost={creationCostPer}
          reloadReservation={reloadReservation}
          walletType={walletType}
        />
        <ConnectWalletModal
          isVisible={connectLoading}
          response={connectSuccess}
          onClick={handleCloseConnect}
        />
      </div>
      <ConnectionOptionModal
        onClose={() => setWalletConnection(false)}
        isVisible={walletConnection}
        iconexConnection={handleLogin}
      />
      <ConnectModal
        isVisible={connectWallet}
        onClose={() => setConnectWallet(false)}
        onConnect={handleLogin}
        icxAmount={creationCostPer}
      />
      <BuyingModal
        isVisible={buyLoading}
        response={buySuccess}
        onClick={handleClose}
        nftCount={Number(nftCount)}
        totalCost={creationCostPer}
        reloadReservation={reloadReservation}
      />
      <ConnectWalletModal
        isVisible={connectLoading}
        response={connectSuccess}
        onClick={handleCloseConnect}
      />
    </>
  );
};

export default SalePrice;
